<template>
  <div class="card">

    <div class="card card-custom" >
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label">{{ $t('right.list') }}</h3>
        </div>
        <div class="card-toolbar">
          <Button  v-if="$can(abilities.CREATE_RIGHT)"  btn-class="btn-sm me-3" type="new" id="submit_btn" btn-text="right.create" @click="openCreateModal"></Button>
        </div>

      </div>

      <div class="card-body" >
        <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_right" style="margin-top: 13px !important; cursor:pointer">
          <thead>
          <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
            <th> {{$t("right.name")}}</th>
            <th> {{$t("right.description")}}</th>
            <th>{{$t("actions")}}</th>
          </tr>
          </thead>
        </table>
      </div>

    </div>

    <Create @reloadDatatable="reloadDataTable"/>

    <Update 
      :formEdit="formEditData" 
      @reloadDatatable="reloadDataTable"
    />
  </div>
</template>

<script>
import Create from "@/components/modals/right/Create.vue"
import Update from "@/components/modals/right/Update.vue";
import {BASE_URL} from "@/services/api";
import Button from "@/components/Button"
import {mapActions} from "vuex";
import {nextTick} from "vue";
import {useSwal} from "@/composables/useSwal";
import {Theme} from "@/composables/theming";
import abilities from "@/composables/abilities";
import Ls from "@/services/ls";

export default {
  components: {Create,Update,Button},
  data(){
    const {showSwal} = useSwal()
    return{
      formCreateData: {
        name: '',
        description: '',
      },
      formEditData: {
        id: null,     
        name: '',
        description: '',
        row: null
      },
      formDeleteData: {
        id: null,
        row: null
      },
      payments: {},
      isLoading: false,
      showSwal,
      abilities
    }
  },
  watch:{
    '$i18n.locale': function(value){
      if(value){
        nextTick(() => this.fetchDatas() )
      }
    },
  },

  async mounted(){
      this.fetchDatas()

      $(document).on("click", "#kt_datatable_right .delete_btn", (e) => {
        this.formDeleteData.id = e.target.getAttribute('data-id')
        this.formDeleteData.row = e.target.getAttribute('data-row')
        this.deleteRightRow()
      });
      
      $(document).on("click", "#kt_datatable_right .view_btn_right", (e) => {
        this.$router.push({ name: "settings-rights-view", params: { id: e.target.getAttribute('data-id')} })
      });
  },
  methods: {

    fetchDatas(){
      const AUTH_TOKEN = Ls.get('auth.token')
      const pageLimit = Ls.get('pageLength')

      this.table = $("#kt_datatable_right").DataTable({
        destroy : true,
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength:pageLimit ||  5,
        lengthMenu: [5, 10, 25, 50, 75, 100 ],
        order: [[ 0, 'desc']],
        ajax: {
          url: BASE_URL+"/get/roles/datatables",
          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
            request.setRequestHeader("Company", Ls.get('current.company'));
            },
          data:  function ( d ) {

          }
        },
        columns: [{ data: "name" },{ data: "description" }, { data: "Actions", responsivePriority: -1 }],

        columnDefs: [

          {
            targets: -3,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span data-id="'+ e.id +'" class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -2,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span  class="descriptionRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            width: "16%",
            targets: -1,
            "className": "dt-center",
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {
              let render=""
              if(this.$can(abilities.RIGHT_PERMISSION) ){
                render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'" data-name="'+ e.name +'" class="btn btn-sm btn-clean btn-icon view_btn_right" ><i data-row="'+ l.row +'" data-id="'+ e.id +'" data-name="'+ e.name +'" class="fas fa-user-shield fs-2" style="color: '+Theme.gray +'"></i></a>'

              }
              if(this.$can(abilities.UPDATE_RIGHT) ){
                render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'" data-name="'+ e.name +'" data-description="'+ e.description +'" class="btn btn-sm btn-clean btn-icon edit_btn" title="'+ i18n.global.t('button.edit') +'"><i data-row="'+ l.row +'" data-id="'+ e.id +'" data-name="'+ e.name +'" data-description="'+ e.description +'" class="fas fa-edit fs-2"  style="color: '+Theme.gray +'"></i></a>'
              }
              if(this.$can(abilities.DELETE_RIGHT)){
                render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'" class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i data-row="'+ l.row +'" data-id="'+ e.id +'" class="fas fa-trash fs-2" style="color: '+Theme.gray +'"></i></a>'

              }

              return render
            },
          },

        ],
        language: {
          url: this.$i18n.locale == 'fr' ? "https://cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "https://cdn.datatables.net/plug-ins/1.10.20/i18n/English.json" ,
        }
      });
      $(document).on("click", "#kt_datatable_right .edit_btn", (e) => {
        this.formEditData.id = e.target.getAttribute('data-id')
        this.formEditData.name = e.target.getAttribute('data-name')
        this.formEditData.description = e.target.getAttribute('data-description')
        this.formEditData.row = e.target.getAttribute('data-row')
        $('#editModal').modal('toggle')
      });
    },
    
    openCreateModal(){
      $('#createModal').modal('toggle')
    },
    ...mapActions('role', [
      'createRole',
      'updateRole',
      'deleteRole'
    ]),
    async reloadDataTable(){
      this.table.ajax.reload()
    },
    async deleteRightRow() {
      let response = {}
      this.showSwal(
          '',
          i18n.global.t('swal.right')
      ).then( async (result) => {
          if (result.value) {
            try {
              response = await this.deleteRole(this.formDeleteData.id)
              window.toastr['success'](i18n.global.t("notification.right_deleted"))
              this.table.ajax.reload()
            } catch (e) {
              if (response && response.data) {
                window.toastr['error'](response.data.error)
                return true
              }
            }
          }
      })
    }
  }
}
</script>

